/**
 * Ekran izveštaja dobija `shifts` (smene iz zajedničke trake/ljuske) i prosleđuje ih
 * nasleđenom starom tabu, koji smene čuva u `selectedShifts`. Početni izbor se postavlja u data (a ne naknadnom
 * izmenom), da stari tab ne učita podatke dvaput; kasnije promene trake prepisuju izbor.
 */
export default {
  props: {
    shifts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return { selectedShifts: [...this.shifts] };
  },
  watch: {
    shifts(shifts) {
      this.selectedShifts = [...shifts];
    },
  },
};
